<div class="popover bg-transparent" [style]="{ top: topPx(), left: leftPx() }">

    <div class="popover-content min-w-[240px] max-w-[280px] py-2 rounded shadow-lg">

        <div class="max-h-[140px] overflow-y-auto">
            @for(suggestion of suggestions(); track i; let i = $index) {
            <div class="min-w-[180px] min-h-[48px] p-2 mx-2 flex flex-row items-center hover:bg-slate-200 hover:cursor-pointer rounded"
                (click)="suggestion.command()">
                <ia-avatar [fname]="suggestion.item.name" [small]="true" /><span
                    class="ml-3">{{suggestion.item.name}}</span>
            </div>
            }
            @if(suggestions().length === 0) {
            <div class="min-w-[180px] min-h-[48px] p-2 flex flex-row items-center">
                <span class="p-2 mx-2">No suggestions found</span>
            </div>
            }
        </div>

    </div>

</div>